import { Card } from "@clipboard-health/ui-components";
import { Box, CardContent, Skeleton, Stack, useTheme } from "@mui/material";

function ShiftHistoryCardSkeleton() {
  const theme = useTheme();

  return (
    <Card
      outlined
      sx={{ flexGrow: 1 }}
      role="progressbar"
      aria-label="Loading shift history"
      variant="tertiary"
    >
      <CardContent sx={{ padding: theme.spacing(6) }}>
        <Stack spacing={6} direction="column">
          <Stack direction="row" spacing={4} alignItems="flex-start">
            <Skeleton variant="rounded" width={48} height={48} />
            <Stack spacing={1} sx={{ flexGrow: 1 }}>
              <Skeleton variant="text" width="40%" height="1.25rem" />
              <Skeleton variant="text" width="60%" height="1.25rem" />
              <Skeleton variant="text" width="40%" height="1.25rem" />
              <Skeleton variant="text" width="75%" height="1.25rem" />
            </Stack>
          </Stack>

          <Stack spacing={2}>
            <Skeleton variant="text" width="90%" height="1.5rem" />
            <Skeleton variant="text" width="80%" height="1.5rem" />
            <Skeleton variant="text" width="70%" height="1.5rem" />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

function ShiftHistoryListItemSkeleton() {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        paddingY: theme.spacing(5),
        borderBottom: `1px solid ${theme.palette.border?.subtle}`,
        backgroundColor: theme.palette.background.tertiary,
      })}
      role="progressbar"
      aria-label="Loading shift history"
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ width: "100%" }}
      >
        <Stack spacing={2} sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton variant="text" width="30%" height="0.875rem" />
          <Skeleton variant="text" width="55%" height="1rem" />
          <Skeleton variant="text" width="45%" height="0.875rem" />
        </Stack>

        <Stack alignItems="flex-end" justifyContent="center" sx={{ flexShrink: 0 }}>
          <Skeleton variant="text" width={60} height="1rem" />
        </Stack>
      </Stack>
    </Box>
  );
}

interface ShiftHistoryLoadingPageStateProps {
  isRedesignEnabled: boolean;
}

export function ShiftHistoryLoadingPageState(props: ShiftHistoryLoadingPageStateProps) {
  const { isRedesignEnabled } = props;

  if (isRedesignEnabled) {
    return (
      <Stack>
        <Stack direction="row" alignItems="center" spacing={6} sx={{ paddingBottom: 2 }}>
          <Skeleton variant="text" width={120} height="1.75rem" />
          <Skeleton variant="circular" width={24} height={24} />
        </Stack>
        {Array.from({ length: 5 }, (_, index) => (
          <ShiftHistoryListItemSkeleton key={index} />
        ))}
      </Stack>
    );
  }

  return (
    <Stack spacing={6}>
      {Array.from({ length: 5 }, (_, index) => (
        <ShiftHistoryCardSkeleton key={index} />
      ))}
    </Stack>
  );
}
